import { useMemo } from 'react';
import { determineDocumentAccessRole } from 'store/modules/upload-documents/actionRules';
import { useRootStore } from 'store/rootStore';
import { DocumentAccessRole } from 'types/documentsService';

/* Requires an instance of RootStore in it's context. */
export const useDocumentAccessRole = (): DocumentAccessRole => {
  const {
    userStore: { userRoles },
  } = useRootStore();

  return useMemo(() => determineDocumentAccessRole(userRoles), [userRoles]);
};
